import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <span className={`inline-block text-xs font-sans font-semibold uppercase tracking-[0.3em] text-indic-gold/90 ${className}`}>
      {children}
    </span>
  );
}

export function SectionTitle({ eyebrow, title, subtitle, center = false }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl`}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold text-amber-50/95 leading-tight text-balance">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-base sm:text-lg text-slate-300/80 leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function GoldLine({ className = "" }) {
  return <div className={`hairline-gold ${className}`} />;
}
